import * as devisConf from '@/configuration/devisConf';
import validationRegroupementPersonnaliseCommande from './validationCreationRegroupementPersoCommande';

function validationContenuType(lignesCommandesAREgrouper, messages) {
  const nbLignesNormalOuRegroupement = lignesCommandesAREgrouper.filter(ligne => {
    return ligne.type === devisConf.REGROUPEMENT
      || ligne.type === devisConf.NORMAL;
  }).length;
  if (nbLignesNormalOuRegroupement !== lignesCommandesAREgrouper.length) {
    messages.push({ message: 'ligneRegroupementPersonnalisee.errors.typeLine' });
    return false;
  }
  return true;
}

function validationPasDejaRegroupe(lignesCommandesAREgrouper, messages) {
  if (lignesCommandesAREgrouper.find(ligne => {
    return !!ligne.referencePersonnalise;
  })) {
    messages.push({ message: 'ligneRegroupementPersonnalisee.errors.alreadyGroup' });
    return false;
  }
  return true;
}

function validationMemeTva(lignesCommandesAREgrouper, messages) {
  let tauxTva = [];
  lignesCommandesAREgrouper.forEach(ligne => {
    if (ligne.type === devisConf.REGROUPEMENT) {
      tauxTva = tauxTva.concat(ligne.lignesCommande
        .filter(ligneEnfant => {
          return ligneEnfant.type === devisConf.NORMAL;
        })
        .map(ligneEnfant => {
          return ligneEnfant.tauxTva;
        }));
    }
    if (ligne.type === devisConf.NORMAL) {
      tauxTva.push(ligne.tauxTva);
    }
  });
  const ligneMemeTva = tauxTva.every(tva => {
    return tva === tauxTva[0];
  });
  if (!ligneMemeTva) {
    messages.push({ message: 'ligneRegroupementPersonnalisee.errors.sameTva' });
    return false;
  }
  return true;
}

function validationOrdreConsecutif(lignesCommandesAREgrouper, devisCommande, messages) {
  const ordres = lignesCommandesAREgrouper.map(ligne => {
    return ligne.ordre;
  });
  const max = Math.max(...ordres);
  const min = Math.min(...ordres);
  const ligneNonSelection = devisCommande
    .lignesCommande.filter(l => !l.selected || l.selected === undefined);
  const ligneAuMileuSelection = ligneNonSelection.find(ligne => {
    return ligne.ordre >= min && ligne.ordre <= max;
  });
  if (ligneAuMileuSelection) {
    messages.push({ message: 'ligneRegroupementPersonnalisee.errors.order' });
    return false;
  }
  return true;
}

function checkLigneInDevisCommandePartiellement(lignesCommandesAREgrouper, lignesInDevis) {
  const ordres = lignesInDevis
    .filter((ligne) => {
      return ligne.commandeId;
    })
    .map(ligne => ligne.ordre);
  const maxOrdre = Math.max(...ordres);
  return lignesCommandesAREgrouper.every((ligne) => {
    return ligne.ordre > maxOrdre;
  });
}

export default function validationRegroupementPersonnalise(
  lignesCommandesAREgrouper, devisCommande, messages,
) {
  if (!lignesCommandesAREgrouper || lignesCommandesAREgrouper.length < 1) {
    messages.push({ message: 'ligneRegroupementPersonnalisee.errors.leastOneLine' });
    return false;
  }
  if (devisCommande.etat === devisConf.ETAT_COMMANDE_PARTIELLEMENT
    && !checkLigneInDevisCommandePartiellement(
      lignesCommandesAREgrouper, devisCommande.lignesCommande,
    )) {
    messages.push({ message: 'ligneRegroupementPersonnalisee.errors.ligneCommandePartiellement' });
    return false;
  }
  let retour = true;
  retour = validationContenuType(lignesCommandesAREgrouper, messages) && retour;
  retour = validationPasDejaRegroupe(lignesCommandesAREgrouper, messages) && retour;
  retour = validationMemeTva(lignesCommandesAREgrouper, messages) && retour;
  retour = validationOrdreConsecutif(
    lignesCommandesAREgrouper, devisCommande, messages,
  ) && retour;
  if (devisCommande.type === devisConf.TYPE_COMMANDE) {
    retour = validationRegroupementPersonnaliseCommande(lignesCommandesAREgrouper,
      devisCommande, messages)
      && retour;
  }
  return retour;
}
